import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { Job, JobStatus } from '@nimmsta/ng-commons-lib/models';
import { Observable, of } from 'rxjs';

export class StatusDependentAction extends CustomAction<Job> {
  constructor(
    _text: string,
    private activeStatuses: JobStatus[] = [],
    isDelete = false,
  ) {
    super(_text, false, isDelete);
  }

  override isEnabled(item: Job): Observable<boolean> {
    return of(this.activeStatuses.indexOf(item.status) >= 0);
  }
}
